export function isIeLessThan9() {
  const div = document.createElement('div')

  div.innerHTML = '<!--[if lt IE 9]><i></i><![endif]-->'

  return div.getElementsByTagName('i').length === 1
}
